export async function isBroadcastChannelSupported(): Promise<boolean> {
  if (typeof window === 'undefined' || !('BroadcastChannel' in window)) {
    return false;
  }

  if (isInIframe()) {
    console.log('iframe loaded ✅');
    return false;
  }

  return true;
}

export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
export function getPathFromUrl(url: string): string {
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.pathname + parsed.search + parsed.hash;
  } catch (e) {
    return url;
  }
}
